import { Post } from "../utils/http.js"

export function getIsOnline(params, config = {}) {
  let url = "/api/mem/auth/isOnline"
  if (process.server) {
    url = "/api/member/auth/isOnline"
  }
  return Post(url, params, {
    ...config,
    baseURL: process.server ? process.env.VUE_APP_MEMBER_API_URL : undefined
  })
}

export function getAccountInfo(params, config = {}) {
  return Post("/api/member/infoPoint", params, config)
}

export function logOut(params) {
  return Post("/api/mem/auth/logout", params)
}
